<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="fill-height d-flex flex-column">
            <sign-head v-model="tab" v-bind="{ contract: form }" />
            <v-divider />
            <div style="flex:1; overflow:hidden">
                <sign-tabs v-model="tab" v-bind="{ contract: form }" v-slot="{ prev, next }">
                    <tabs-view v-model="form" v-on="{ exit, next }" />
                    <tabs-form v-model="form" v-on="{ prev, next }" />
                    <tabs-file v-model="form" v-on="{ prev, next }" />
                    <tabs-save v-on="{ prev, save }" />
                    <tabs-done v-on="{ exit }" />
                    <!-- 완료 -->
                </sign-tabs>
            </div>
            <client-loader v-bind="{ loading }" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import { TABS } from "./sign/lib";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import SignHead from "./sign/sign-head.vue";
import SignTabs from "./sign/sign-tabs.vue";
import TabsDone from "./sign/tabs/tabs-done.vue";
import TabsFile from "./sign/tabs/tabs-file.vue";
import TabsForm from "./sign/tabs/tabs-form.vue";
import TabsSave from "./sign/tabs/tabs-save.vue";
import TabsView from "./sign/tabs/tabs-view.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        SignHead,
        SignTabs,
        TabsDone,
        TabsFile,
        TabsForm,
        TabsSave,
        TabsView,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),
        tab: TABS.VIEW.value,
        shows: false,
        loading: false,
    }),
    computed: {
        title() {
            return `"${this.form.subject}" 서명하기`;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (!this.shows) return;
            this.tab = TABS.VIEW.value;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { contract } = await api.v1.person.employment.contracts.get({ _id: this.value._id });
                this.form = initEmploymentContract(contract);
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (!this.validate()) return;
            let go = confirm("서명 완료 후 더 이상 수정하실 수 없습니다.\n서명하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { _id, fields_employee } = this.form;

                fields_employee = await Promise.all(
                    fields_employee.map(async (item) => {
                        switch (item.type) {
                            case EMPLOYMENT_FIELD_TYPES.FILE.value: {
                                if (item.file instanceof File) {
                                    item.file = (await api.v1.person.employment.files.post({ code: item.type }, item.file))?.file;
                                }
                                item._file = item?.file?._id || null;
                                delete item.file;
                                break;
                            }
                            case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                                if (item.img instanceof File) {
                                    item.img = (await api.v1.person.employment.files.post({ code: item.type }, item.img))?.file;
                                }
                                item._img = item?.img?._id || null;
                                delete item.img;
                                break;
                            }
                        }

                        return item;
                    })
                );

                let { contract } = await api.v1.person.employment.contracts.put({ _id, fields_employee });
                this.form = initEmploymentContract(contract);

                alert("계약서의 서명을 완료하였습니다");

                this.loading = false;
                this.tab = TABS.DONE.value;
            } finally {
                this.loading = false;
            }
        },

        validate() {
            const fields_required = this.form.fields_employee.filter((item) => item.isRequired);
            const fields_unfilled = fields_required.filter((item) => {
                switch (item.type) {
                    case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                        return !item.data;
                    }
                    case EMPLOYMENT_FIELD_TYPES.DATE.value: {
                        return !item.data;
                    }
                    case EMPLOYMENT_FIELD_TYPES.FILE.value: {
                        return !item.file;
                    }
                    case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                        return !item.img;
                    }
                    case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                        return !item.data;
                    }
                }
            });

            if (0 < fields_unfilled.length) {
                alert(`필수입력 필드 ${fields_required.length}개 중 ${fields_unfilled.length}개가 입력되지 않았습니다.`);
                return false;
            }

            return true;
        },

        exit() {
            if (this.tab == TABS.DONE.value) this.$emit("search");
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
